import { SharedState } from '@trello/shared-state';

export enum WorkspaceStateStatus {
  INITIALIZING = 'INITIALIZING',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  READY = 'READY',
  DISABLED = 'DISABLED',
}

export enum WorkspaceStateError {
  NO_MATCHING_ROUTE = 'NO_MATCHING_ROUTE',
}

export interface WorkspaceState {
  status: WorkspaceStateStatus;
  error: WorkspaceStateError | null;
  idWorkspace: string | null;
  isGlobal: boolean;
}

export const initialState: WorkspaceState = {
  status: WorkspaceStateStatus.INITIALIZING,
  error: null,
  idWorkspace: null,
  isGlobal: false,
};

export const workspaceState = new SharedState(initialState);
